export const URL_API_VIET_QR = "https://api.vietqr.io/v2/banks";